import { render, staticRenderFns } from "./GameJurisdictions.vue?vue&type=template&id=5145087d&scoped=true&"
import script from "./GameJurisdictions.vue?vue&type=script&lang=js&"
export * from "./GameJurisdictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145087d",
  null
  
)

export default component.exports